"use client"

import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { Station } from "api"
import { LocationContext } from "contexts/LocationProvider"
import { useContext } from "react"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import { Desktop, LocatorArrowRight, Mobile, NewText } from "ui"
import SwiperContainer from "./SwiperStationsContainer"

const SwiperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
  width: 100%;
`
const SwiperBox = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 0 8px 0;
`

const StyledArrows = styled.div`
  display: flex;
  gap: 22px;
`
const StyledArrowContainer = styled(Button)`
  margin: 0;
  padding: 0;
  height: 24px;
  width: 24px;

  min-width: 0;
  &:disabled {
    svg {
      path {
        stroke: #b9c5d2;
      }
    }
  }
`

export default function LocationsSwiper({
  locations
}: {
  locations: Station[]
}) {
  const { selectedLocation } = useContext(LocationContext)
  if (!selectedLocation) {
    return null
  }
  return (
    <SwiperBox>
      <Desktop>
        <SwiperHeader aria-label="תחנות בסביבה שלך">
          <NewText
            component={"h2"}
            largeDesktopFontSize={20}
            largeDesktopLineHeight="28px"
            desktopFontSize={14}
            desktopLineHeight={"20px"}
            desktopFontWeight={500}
            color="black"
          >
            בסביבה
          </NewText>
          <StyledArrows>
            <StyledArrowContainer className={`arrow-right arrow`} aria-label="לתחנה הקודמת">
              <LocatorArrowRight active={true} />
            </StyledArrowContainer>

            <StyledArrowContainer className={`arrow-left arrow`}>
              <LocatorArrowRight style={{ transform: "scale(-1)" }} aria-label="לתחנה הבאה" />
            </StyledArrowContainer>
          </StyledArrows>
        </SwiperHeader>
      </Desktop>
      <Mobile>
        <SwiperContainer locations={locations} />
      </Mobile>
      <Desktop>
        <SwiperContainer locations={locations} />
      </Desktop>
    </SwiperBox>
  )
}
